import _ from 'lodash';
import React from 'react';
import styled, { StylesProps, cx } from '../../../../lib/styles';
import { Color, Brand } from '../../../../lib/theme';
import Icon from '../../Icon';

import fabStyles from './Fab_styles';

type FabSize = 's' | 'm';

export interface FabProps {
  size?: FabSize;
  brand?: Brand;
  color?: Color;
  iconColor?: Color;
  icon:
    | {
        name: string;
        className: string;
      }
    | string;
  url?: string;
  onClick?: (event: any) => any;
  className?: string;
}

const Fab = ({
  icon,
  url,
  onClick,
  className,
  styles,
}: FabProps & StylesProps<typeof fabStyles>) => {
  const containerProps = url ? {} : { type: 'button' as 'button' };

  return url ? (
    <a className={cx(styles.container, className)} onClick={onClick} href={url}>
      {_.isObject(icon) ? (
        <Icon className={icon.className} icon={null} />
      ) : (
        <i className={`sas-icon-${icon}`} />
      )}
    </a>
  ) : (
    <button
      {...containerProps}
      className={cx(styles.container, className)}
      onClick={onClick}
    >
      {_.isObject(icon) ? (
        <Icon className={icon.className} icon={null} />
      ) : (
        <i className={`sas-icon-${icon}`} />
      )}
    </button>
  );
};

export default styled(fabStyles)(Fab);
